import {
    OPTILE_INIT_SUCCEEDED,
    OPTILE_SUBMITTING_SUCCEEDED,
    OPTILE_SUBMITTING_LOADING,
    OPTILE_SUBMITTING_ERROR,
    OPTILE_PAYMENT_AUTORISE
} from '../actions/constants/action-types';

const INITIAL_STATE = {
    loaded: false,
    loadingForm: false,
    dataAfterPay: {
        redirect: {},
        message: ''
    },
    dataInit: {
        cancelUrl: '',
        failureUrl: '',
        listId: '',
        networks: [],
        holderName: '',
        amount: 0,
        currency: '',
        networkAccounts: [],
        iframeUrl: ''
    },
    dataBankPayment: {},
    error: ''
};

export default (state = INITIAL_STATE, action) => {
    switch (action.type) {
        case OPTILE_INIT_SUCCEEDED: {
            const {payload: dataInit} = action;
            return {
                ...state,
                dataInit,
                loaded: true
            };
        }
        case OPTILE_SUBMITTING_SUCCEEDED: {
            const {payload: data} = action;
            return {
                ...state,
                dataAfterPay: {
                    ...data
                }
            };
        }
        case OPTILE_SUBMITTING_LOADING: {
            const {payload: loaded} = action;
            return {
                ...state,
                loadingForm: loaded
            };
        }
        case OPTILE_SUBMITTING_ERROR: {
            const {payload: message} = action;
            return {
                ...state,
                error: message
            };
        }
        case OPTILE_PAYMENT_AUTORISE: {
            const {payload: data} = action;
            return {
                ...state,
                dataBankPayment: {
                    ...data
                }
            };
        }
        default: {
            return state;
        }
    }
};
